import { render, staticRenderFns } from "./VersionFileUpload.vue?vue&type=template&id=9c199db0&"
import script from "./VersionFileUpload.vue?vue&type=script&lang=js&"
export * from "./VersionFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./VersionFileUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports